import { render, staticRenderFns } from "./topic-list.vue?vue&type=template&id=17fe99de&scoped=true"
import script from "./topic-list.vue?vue&type=script&lang=js"
export * from "./topic-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fe99de",
  null
  
)

export default component.exports